import { render, staticRenderFns } from "./trendDetails.vue?vue&type=template&id=bdf257da&scoped=true"
import script from "./trendDetails.vue?vue&type=script&lang=js"
export * from "./trendDetails.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/common.css?vue&type=style&index=0&id=bdf257da&prod&scoped=true&lang=css&external"
import style1 from "../../../static/css/trendDetails.css?vue&type=style&index=1&id=bdf257da&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf257da",
  null
  
)

export default component.exports